export const ValidateUrl=(str)=> {
    var pattern = new RegExp('^(https?:\\/\\/)', 'i');
    return !!pattern.test(str);
}